import {  JobCategory } from '../jobCategory';


export class JobCategorySerializer {
    fromJson(json: any): JobCategory {
        const data = new JobCategory();
        data.value = json.id;
        data.label = json.name;
        return data;
    }

    toJson(data: JobCategory): any {
        return {
            id: data.id,
            name: data.name
        };
    }
}